import React from 'react';
import { Spin, Table } from 'antd';
import 'antd/dist/antd.less';
import './ant-table.css';
import { CommunitiesHelpers } from '../../communities.js';
import { Translate } from 'react-localize-redux';
import './communityCatalog.css';
import CommunityCatalogsTableRow from './CommunityCatalogsTableRow';
import api from '../../Api';

export class CommunityCatalogs extends React.Component {
	constructor(props) {
		super(props);

		let columns = this.buildColumns();
		this.state = {
			columns: columns,
			visible: false,
			dataRetrieved: false,
			catalogRetrieving: false,
		};
	}

	componentDidMount() {
		let communityCatalogsUrl = `/api/v1/catalogs/communities/${
			this.props.match.params.communityId
		}?daysBack=${
			this.props.match.params.catalogsCreatedDateMaxDaysBack
		}&height=100`;

		this.fetchRequest = api.cancelableGet(communityCatalogsUrl);
		const { promise } = this.fetchRequest;

		promise.then(catalogs => {
			let rows = [];
			for (let i in catalogs) {
				rows.push({
					key: catalogs[i].catalogId,
					catalogId: catalogs[i].catalogId,
					catalogName: catalogs[i].catalogName,
					catalogImagePath: catalogs[i].catalogImagePath,
					userAvatar: catalogs[i].userAvatar,
					userName: catalogs[i].userName,
					updatedDate: new Date(catalogs[i].updatedDate),
					sharedDate: new Date(catalogs[i].sharedDate),
				});
			}

			this.setState({
				data: rows,
				dataRetrieved: true,
			});
		});
	}

	componentWillUpdate() {
		this.fetchRequest.cancel();
	}

	buildColumns = () => {
		let columns = [
			{
				title: <span>&nbsp;</span>,
				render: row => <CommunityCatalogsTableRow row={row} />,
			},
		];
		return columns;
	};

	render() {
		return (
			<div>
				{this.state.dataRetrieved ? (
					<Spin spinning={this.state.catalogRetrieving}>
						<div className="flex-container flex-column">
							<div>
								<Table
									size="small"
									columns={this.state.columns}
									dataSource={this.state.data}
									pagination={{
										pageSize: 4,
									}}
									rowClassName={(record, index) =>
										CommunitiesHelpers.getStripedClassName(
											index,
										)
									}
									scroll={{
										y: this.props.tableHeight || 525,
									}}
								/>
							</div>
						</div>
					</Spin>
				) : (
					<Spin spinning={this.state.loading}>
						<div className="middle-frame" />
					</Spin>
				)}
			</div>
		);
	}
}
